import type { ICitiesSettings } from '../../models';

import { useAutoDetectFiasId } from './use-auto-detect-fias-id';
import { useCityByGeo } from './use-city-by-geo';
import { useTopCities } from './use-top-cities';
import { useCitiesBySearch } from './use-cities-by-search';

export function useCities({
    aliases,
    cityPath,
    geoGroups,
    topCities: topCitiesFiasId,
}: ICitiesSettings) {
    const { cities, searchWord, setSearchWord } = useCitiesBySearch({ aliases, geoGroups });
    const autoDetectedFiasId = useAutoDetectFiasId();
    const currentCity = useCityByGeo(cityPath);
    const topCities = useTopCities({ autoDetectedFiasId, currentCity, topCities: topCitiesFiasId });

    return {
        searchValue: searchWord,
        changeSearch: setSearchWord,
        autoDetectedFiasId,
        top: topCities,
        currentCity,
        bySearch: cities,
    };
}
